(function($){

	/*
	$('.toggleAccordion').click(function(){

		$(this).next().slideToggle('fast');
		$(".accordionContent").not($(this).next()).slideUp('fast');

	});

	$('.toggleAccordion').click(function(){

		$(this).toggleClass("open").next().toggleClass("open");
		$(".accordionContent").not($(this).next()).removeClass('open');
		$(".toggleAccordion").not($(this)).removeClass('open');

	});
	*/

	$('.listAccordion > li > div').click(function(){
		$(this).parent().toggleClass("open");
		$(".listAccordion > li > div").not($(this)).parent().removeClass('open');
	});

	
})(jQuery)

